import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchErrorState'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "We're having trouble with search",
  },
  content: {
    id: `${scope}.content`,
    defaultMessage:
      'Try again in a few minutes or browse your modules manually.',
  },
})
